import { Injectable } from "@angular/core";
import { MatDialog } from '@angular/material/dialog';
import { CustomMessageComponent, CustomMessageData } from "./custom-message.component";

/**
 * Mientras un módulo hace su carga inicial (app-page-loader visible) no se
 * abren los avisos de "Cargando…" / "¡Hecho!": la pantalla de carga ya lo
 * dice. Los errores y advertencias, y lo que pide confirmación, sí salen.
 */
export const pageLoadGate = { active: 0 };

@Injectable({ providedIn: "root" })
export class CustomMessageService {

  private dialogRef: any;

  constructor(private dialog: MatDialog) {}

  open(data: CustomMessageData): Promise<boolean> {
    const d: any = data ?? {};
    const informative = !d.acceptBtn && !d.dismissBtn && d.type !== 'error' && d.type !== 'warning';
    if (pageLoadGate.active > 0 && informative) return Promise.resolve(false);
    this.dialogRef = this.dialog.open(CustomMessageComponent, {
      disableClose: true,
      minWidth: '300px',
      maxWidth: '420px',
      panelClass: 'cm-panel',
      data,
    });

    return new Promise((resolve) => {
      this.dialogRef.afterClosed().subscribe((result: boolean) => {
        resolve(result);
      });
    });
  }

  close(): void {
    this.dialogRef?.close();
  }
}